import { render, staticRenderFns } from "./addAndModiify.vue?vue&type=template&id=1ac1abc1&scoped=true&"
import script from "./addAndModiify.vue?vue&type=script&lang=js&"
export * from "./addAndModiify.vue?vue&type=script&lang=js&"
import style0 from "./addAndModiify.vue?vue&type=style&index=0&id=1ac1abc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1abc1",
  null
  
)

export default component.exports